const jobResponseToJobObject = (response) => {
    if (!response) {
        return null;
    }
    return {
        id: response.id,
        jobType: response.job_type,
        status: response.status,
        userId: response.user_id,
        integrationId: response.integration_id,
        description: response.description,
        message: response.message,
        error: response.error,
        createdAt: response.created_at,
        updatedAt: response.updated_at,
        startedAt: response.started_at,
        completedAt: response.completed_at,
    };
};

export { jobResponseToJobObject };
